// extracted by mini-css-extract-plugin
export default {"inputField":"style_inputField__O44CO","ageGen":"style_ageGen__C1wQs"};